<div class="modal-summary" *ngIf="isSummary">
  <div class="loader container" *ngIf="isLoading">
    <lib-loading></lib-loading>
  </div>
  <form class="container" [formGroup]="formSummary" *ngIf="!isLoading">
    <div class="summary-form">
      <!-- HEADER -->
      <div class="summary-header">
        <p>Resumo</p>
        <button class="btn btn-close" (click)="closeModal()">
          <img src="../../../assets/svgs/close_btn.svg" alt="Fechar">
        </button>
      </div>

      <div class="summary-list">
        <p class="item"><span class="title">Produto:</span>{{ formSummary.get('product_name').value }} - <a class="link" target="_blank" href="/produtos/ficha/{{formSummary.get('sku').value}}">Ficha do imóvel</a></p>
        <p class="item"><span class="title">Mercado:</span>Primário</p>
        <p class="item"><span class="title">Início:</span>{{ formSummary.get('validity').value.start | date:'dd/MM/yy' }}</p>
        <p class="item"><span class="title">Término:</span>{{ formSummary.get('validity').value.end | date:'dd/MM/yy'  }}</p>
        <p class="item"><span class="title">Investimento:</span>{{ formSummary.get('value_invest').value }}</p>
        <p class="item" *ngIf="isSegmentationAvailable"><span class="title">Tipo de segmentação:</span>{{ formSummary.get('type_segmentation').value.title }}</p>
      </div>

      <ul class="participants">
        <li class="items" *ngFor="let user of getParticipants(); let i = index">
          <app-participants-card 
          [editable]="false"
          [index]="i" 
          [user]="user">
          </app-participants-card>
        </li>
      </ul>

    </div>
    <div class="footer-modal">
      <lib-button-tertiary class="btn" 
      (click)="closeModal()">
        Voltar
      </lib-button-tertiary>
      <lib-button-primary class="btn" 
      (click)="save()">
        Confirmar
      </lib-button-primary>
    </div>
  </form>
</div>